import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";

const defaultContactAccountUpdateObj = {
  contactCount: 0,
  contactIds: [],
  allContactsSelectedInView: false,
  searchFilter: {}
};

class ContactAccountUpdateState {
  @observable showChangeAccountPopup = false;
  @observable contactAccountUpdateObj = { ...defaultContactAccountUpdateObj };

  @action
  setShowChangeAccountPopup = (val = false) => {
    this.showChangeAccountPopup = val;
  };

  @action
  setContactAccountUpdateObj = (obj = {}) => {
    this.contactAccountUpdateObj = obj;
  };

  @action
  resetContactAccountUpdateObj = () => {
    this.contactAccountUpdateObj = { ...defaultContactAccountUpdateObj };
  };

  @action
  changeContactsAccount = async (
    targetAccountId = "",
    contactIds = [],
    allContactsSelectedInView = false,
    totalCount = 0,
    searchFilter = {}
  ) => {
    const config = {
      url: URLS.performContactsBulkOperation,
      method: "POST",
      data: {
        source: "CONTACT",
        type: "CONTACT_ACCOUNT_UPDATE",
        totalCount,
        filter: {
          ...(allContactsSelectedInView ? {} : { contactIds })
        },
        // "select all" has no explicit contactIds — the backend resolves "all" via this
        // search payload instead, same convention as Move to List / Enrich. Without it,
        // "select all" would ignore the currently applied view/account scope entirely.
        ...(allContactsSelectedInView && { search: searchFilter }),
        data: {
          targetAccountId
        }
      }
    };
    return await makeApi(config);
  };
}

const contactAccountUpdateState = new ContactAccountUpdateState();
export { contactAccountUpdateState };
